import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BagIcon from '../BagIcon';
import StaticIcon from '../StaticIcon';
var Button = styled.button.attrs(function (_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type;
  return {
    type: type
  };
}).withConfig({
  displayName: "IconButton__Button",
  componentId: "swn8ex-0"
})(["\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0;\n\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"], function (props) {
  return props.theme.focusColor || '#7c89d3';
});

var IconButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(IconButton, _Component);

  function IconButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = IconButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        icon = _this$props.icon,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "icon"]);

    if (icon.type === 'bag') {
      return React.createElement(Button, props, React.createElement(BagIcon, {
        size: icon.size,
        quantity: icon.quantity
      }), " ", children);
    }

    return React.createElement(Button, props, React.createElement(StaticIcon, {
      size: icon.size,
      type: icon.type
    }), " ", children);
  };

  return IconButton;
}(Component);

_defineProperty(IconButton, "propTypes", {
  /**
   * Element rendered to the right of the icon
   */
  children: PropTypes.node,

  /**
   * If set to "bag", these props are passed to `BagIcon`, otherwise they are passed to `StaticIcon`.
   */
  icon: PropTypes.shape({
    size: PropTypes.number,
    type: PropTypes.string.isRequired
  })
});

export { IconButton as default };